import React from "react"
import ReactDOM from 'react-dom/client';
import App from "./App"
import { BrowserRouter } from "react-router-dom"
import "./i18n"

import { Provider } from "react-redux"

// import store from "./store"
import Store from "redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <Provider store={Store}>
      <React.Fragment>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Fragment>
    </Provider>
);